import type { SamlSsoModelInvitation, SamlSsoModelSuccessfulResponse } from './model';
import type { SamlSsoRegistrationRequestBody, SamlSsoResponseSuccess } from './dto';

export const mapDtoFieldKeysToModelKeys = (field: string): string | null => {
  const keyMap: {
    [key: string]: string;
  } = {
    name: 'name',
    role: 'role',
    accept_terms: 'terms',
    invitation_token: 'invitationToken',
  };

  return keyMap[field] || null;
};

export const samlInvitationModelToDto = ({
  name,
  role,
  terms,
  invitationToken,
}: SamlSsoModelInvitation): SamlSsoRegistrationRequestBody => ({
  name,
  role,
  accept_terms: terms,
  invitation_token: invitationToken,
});

export const samlResponseInvitationDtoToModel = (
  response: SamlSsoResponseSuccess,
): SamlSsoModelSuccessfulResponse => ({
  nextUrl: response.next_url,
});
